import { ScoreCard } from "@/components";
import {
  HistoryVoucher,
  StatsHistoryVoucher,
} from "@/components/historyvoucher";
import { HistoryVoucherType, VoucherStats } from "@/types";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { useTranslate } from "react-admin";

type EntityDashboardProps = {
  dataChart: VoucherStats | null;
  historyVoucher: HistoryVoucherType[];
};

const EntityDashboard = ({
  dataChart,
  historyVoucher,
}: EntityDashboardProps) => {
  const translate = useTranslate();

  const hasHistory = historyVoucher.length > 0;

  return (
    <Box>
      <Grid size={12}>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
          {translate("ra.gameoo.statsVoucherLabel")}
        </Typography>
      </Grid>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 3 }}>
          <ScoreCard
            title={translate("ra.gameoo.statsBogoLabel")}
            count={dataChart?.bogo_count ?? 0}
            quantity={dataChart?.bogo_quantity ?? 0}
            claimed={dataChart?.bogo_claimed ?? 0}
            consumed={dataChart?.bogo_consumed ?? 0}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 3 }}>
          <ScoreCard
            title={translate("ra.gameoo.statsFreeProductLabel")}
            count={dataChart?.free_product_count ?? 0}
            quantity={dataChart?.free_product_quantity ?? 0}
            claimed={dataChart?.free_product_claimed ?? 0}
            consumed={dataChart?.free_product_consumed ?? 0}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 3 }}>
          <ScoreCard
            title={translate("ra.gameoo.statsDiscountLabel")}
            count={dataChart?.discount_count ?? 0}
            quantity={dataChart?.discount_quantity ?? 0}
            claimed={dataChart?.discount_claimed ?? 0}
            consumed={dataChart?.discount_consumed ?? 0}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 3 }}>
          <ScoreCard
            title={translate("ra.gameoo.statsGiftCardLabel")}
            count={dataChart?.gift_card_count ?? 0}
            quantity={dataChart?.gift_card_quantity ?? 0}
            claimed={dataChart?.gift_card_claimed ?? 0}
            consumed={dataChart?.gift_card_consumed ?? 0}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} mt={5}>
        {!hasHistory ? (
          <Grid size={12}>
            <Paper
              sx={{
                p: 3,
                textAlign: "center",
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" color="text.secondary">
                Aucun historique de voucher pour le moment.
              </Typography>
            </Paper>
          </Grid>
        ) : (
          <>
            <Grid size={{ xs: 12, lg: 6 }}>
              <HistoryVoucher data={historyVoucher} />
            </Grid>

            <Grid size={{ xs: 12, lg: 6 }}>
              <StatsHistoryVoucher history={historyVoucher} />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default EntityDashboard;
